import { render, staticRenderFns } from "./SeminarEdit.vue?vue&type=template&id=41e7aee5&scoped=true&"
import script from "./SeminarEdit.vue?vue&type=script&lang=js&"
export * from "./SeminarEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e7aee5",
  null
  
)

export default component.exports